import React from 'react';
import { Container } from 'react-bootstrap';

const TermsOfServicePage = () => {
  return (
    <Container className="my-4">
      <h1>Términos y Condiciones de Uso</h1>
      <p className="text-muted">Última actualización: 17 de octubre de 2026</p>

      <h2 className="mt-4">1. ACEPTACIÓN DE LOS TÉRMINOS</h2>
      <p>
        Al registrarse y utilizar Evazard, usted (el "Cliente") acepta vincularse legalmente con Jesús Antonio Castañeda Valencia (en adelante "El Proveedor"), propietario de la marca CValenciaIT. Si no está de acuerdo con estos términos, absténgase de usar el servicio.
      </p>
      <div>
        <strong>Razón Social:</strong> Jesús Antonio Castañeda Valencia<br />
        <strong>Marca Comercial:</strong> CValenciaIT<br />
        <strong>Plataforma:</strong> Evazard<br />
        <strong>Domicilio:</strong> Tuluá, Valle del Cauca, Colombia<br />
        <strong>Correo electrónico de contacto:</strong> cvalenciait.contacto@gmail.com
      </div>


      <h2 className="mt-4">2. DESCRIPCIÓN DEL SERVICIO</h2>
      <p>
        Evazard es una plataforma en la nube (SaaS) diseñada para la gestión de ventas, inventarios y clientes para pequeños y medianos negocios. El Proveedor otorga al Cliente una licencia limitada, revocable, no exclusiva e intransferible para usar el software durante el periodo de suscripción activo.
      </p>

      <h2 className="mt-4">3. CUENTAS Y RESPONSABILIDAD DE ACCESO</h2>
      <p>
        El Cliente es el único responsable de mantener la confidencialidad de su contraseña. El Proveedor no será responsable por pérdidas o daños derivados del acceso no autorizado a la cuenta del Cliente imputables al descuido de este último.
      </p>

      <h2 className="mt-4">4. PAGOS Y FACTURACIÓN</h2>
      <ul>
        <li>El servicio se presta bajo modalidad de prepago (suscripción mensual o anual).</li>
        <li>El Proveedor se reserva el derecho de suspender el acceso al servicio si no se recibe el pago correspondiente.</li>
        <li>Los precios pueden ser modificados con un aviso previo de treinta (30) días calendario.</li>
      </ul>

      <h2 className="mt-4">5. PROPIEDAD INTELECTUAL</h2>
      <p>
        <strong>Del Proveedor:</strong> Jesús Antonio Castañeda Valencia conserva todos los derechos de propiedad intelectual e industrial sobre el software Evazard, su código fuente, diseño, bases de datos y la marca CValenciaIT.
      </p>
      <p>
        <strong>Del Cliente:</strong> El Cliente conserva la total propiedad de los datos, archivos e información que cargue en la plataforma ("Datos del Cliente").
      </p>

      <h2 className="mt-4">6. LIMITACIÓN DE RESPONSABILIDAD (CLÁUSULA IMPORTANTE)</h2>
      <p>
        El servicio se suministra "tal cual" (as is) y "según disponibilidad". Aunque nos esforzamos por mantener la plataforma operativa 24/7:
      </p>
      <ul>
        <li>a) El Proveedor no garantiza que el servicio será ininterrumpido, puntual o libre de errores.</li>
        <li>b) En la máxima medida permitida por la ley colombiana, el Proveedor (actuando como persona natural) no será responsable por daños indirectos, lucro cesante, pérdida de datos o interrupción de negocios derivados del uso del software.</li>
        <li>c) La responsabilidad total acumulada del Proveedor hacia el Cliente no excederá el monto total pagado por el Cliente en los tres (3) meses anteriores al evento que generó el reclamo.</li>
      </ul>

      <h2 className="mt-4">7. POLÍTICA DE USO JUSTO Y LÍMITES DEL SERVICIO</h2>
      <p>
        Para garantizar la estabilidad y disponibilidad del servicio para todos nuestros usuarios, y prevenir usos que excedan el propósito de pequeñas y medianas empresas, Evazard implementa una política de uso justo. Aunque ciertos planes se comercializan como 'ilimitados' en capacidad de ventas o productos, esto se refiere a volúmenes que son prácticamente ilimitados para la operación de un negocio típico en su categoría. Nos reservamos el derecho de aplicar límites técnicos (ej. 50.000 ventas/mes por negocio) para proteger la infraestructura. Los usos que superen estos volúmenes y generen cargas excesivas en nuestros sistemas sin un acuerdo comercial específico, serán contactados para un ajuste de plan o acuerdo personalizado. Esta medida busca asegurar una experiencia óptima para todos.
      </p>

      <h2 className="mt-4">8. CLÁUSULA DE RESPONSABILIDAD FISCAL Y FACTURACIÓN (IMPORTANTE)</h2>

      <h3 className="mt-3">8.1. Naturaleza del Software</h3>
      <p>
        El Cliente reconoce y acepta que Evazard es una herramienta tecnológica diseñada exclusivamente para la gestión administrativa, control de inventarios y registro interno de ventas.
      </p>

      <h3 className="mt-3">8.2. No es Software de Facturación Electrónica</h3>
      <p>
        A menos que se especifique lo contrario en un contrato de servicio adicional, la versión estándar de Evazard <strong>NO constituye un software de facturación electrónica</strong> ni emite "Documentos Equivalentes Electrónicos" en los términos exigidos por la Dirección de Impuestos y Aduanas Nacionales (DIAN) bajo el Decreto 358 de 2020, la Resolución 000042 de 2020 y sus normas modificatorias.
      </p>

      <h3 className="mt-3">8.3. Responsabilidad del Cliente</h3>
      <p>
        Es responsabilidad exclusiva del Cliente determinar si, de acuerdo con su actividad económica y montos de facturación, tiene la obligación legal de expedir Factura Electrónica de Venta.
      </p>
      <p>
        Si el Cliente es un sujeto obligado a facturar electrónicamente, deberá utilizar los mecanismos autorizados por la DIAN para tal fin.
      </p>
      <p>
        El Cliente libera a Evazard y a Jesús Antonio Castañeda Valencia de cualquier sanción, multa o requerimiento fiscal derivado del uso de los comprobantes emitidos por la plataforma como soporte fiscal sin cumplir los requisitos de ley.
      </p>

      <h3 className="mt-3">8.4. Leyenda en Comprobantes</h3>
      <p>
        El Cliente acepta que los comprobantes impresos o digitales generados por Evazard incluirán automáticamente una leyenda aclaratoria indicando que se trata de un documento de control interno.
      </p>

      <h2 className="mt-4">9. LEY APLICABLE Y JURISDICCIÓN</h2>
      <p>
        Estos términos se rigen por las leyes de la República de Colombia. Cualquier controversia será resuelta ante los jueces de la República, preferiblemente en el municipio de Tuluá, Valle del Cauca.
      </p>
    </Container>
  );
};

export default TermsOfServicePage;